import type { InputProps } from '../ui';

export interface DateInputProps extends InputProps {
  format?: string;
}

const DateInput = ({ className, type, ...props }: DateInputProps) => {
  return (
    <input
      type="date"
      {...props}
      value={String(props.value)}
      onChange={props.onChange}
      defaultValue={String(props.defaultValue)}
    />
    //   <PatternFormat
    //     {...props}
    //     getInputRef={() => ref}
    //     format={props.format ?? '##/##/####'}
    //     customInput={Input}
    //     value={String(props.value)}
    //     onChange={props.onChange}
    //     inputMode="tel"
    //     defaultValue={String(props.defaultValue)}
    //   />
  );
};

export default DateInput;
